// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Colors used to distinguish the seven billing-lifecycle rendering keys
 * (6 segments + total cycle) on the lifecycle report (card accents, Gantt
 * bars, table cell text).
 *
 * Tokens that map to the active MUI palette use the token form so theme
 * changes propagate. The three remaining shades (indigo, blue, amber) do
 * not have palette equivalents yet; they are exported as hex constants so
 * every consumer references a single source of truth rather than inlining.
 */

// Charge lag: indigo. No palette token today. Considered a palette extension
// candidate if more surfaces adopt this shade.
export const LIFECYCLE_CHARGE_LAG_HEX = '#6366F1';

// Invoice review: blue. Same status as indigo — no palette token yet.
export const LIFECYCLE_INVOICE_REVIEW_HEX = '#3B82F6';

// Date lag: amber. Distinct from the other ADC segments because date lag is
// sign-symmetric (negative = backdated, positive = future-dated). No palette
// token today.
export const LIFECYCLE_DATE_LAG_HEX = '#F59E0B';

// Delivery lag, actual terms, delinquency, total cycle all map to existing
// palette tokens and are referenced directly by name at call sites (no
// constant re-export needed):
//   * delivery lag → 'success.main'   (teal)
//   * actual terms → 'text.secondary' (neutral slate)
//   * delinquency  → 'error.main'     (red)
//   * total cycle  → 'primary.main'   (primary blue)
